/**
 * Project : workspace
 * File    : AccountScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.account

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowCircleRight
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Power
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import appConfig.AppConfig
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.alert.handler.AlertHandler
import com.parmartechnologies.commerce.feature.customer.viewModel.CustomerViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import common.asset.ImageAsset
import component.address.AddressRow
import component.image.FriendlyIcon
import component.navigation.TopNavBar
import component.profile.MobileNumberRow
import component.profile.ProfileRow
import locale.localization
import navigation.AppNavigator
import navigation.route.account.AccountNavRoute
import presentation.screens.customer.membership.MembershipRow
import theme.ThemeColor

/**
 * Represents the account screen class.
 */

class AccountScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val selectedBusiness = businessViewModel.selectedBusiness.collectAsState()
        val customerViewModel = CustomerViewModel(selectedBusiness.value)
        val viewModel = AuthViewModel()
        val selectedLanguage = viewModel.selectedLanguage.collectAsState()
        val customer = customerViewModel.customer.collectAsState()
        val user = viewModel.authUser.collectAsState()
        val isLoggedIn = viewModel.isLoggedIn.collectAsState()
        LaunchedEffect(key1 = Unit) {
            AuthHandler.shared().checkIfLoggedIn()
//            customerViewModel.loadMembership(
//                mobile = user.value.MobileNumber, dialCode = user.value.DialCode
//            )
        }
        if (isLoggedIn.value) {
            Column(
                modifier = Modifier
                    .fillMaxSize().padding(bottom = 8.dp)
            ) {
                TopNavBar(localization().accounts.accountsTitle, AppNavigator.shared().getNavigationParam())
                LazyColumn(
                    modifier = Modifier
                        .fillMaxWidth().weight(1f)
                ) {
                    item {
//                        AppLoader(viewModel)
//                        CircularImageView(id = user.value._id, true)
                    }
                    item {
                        Spacer(modifier = Modifier.height(15.dp))
                        ProfileRow(viewModel)
                        Spacer(modifier = Modifier.height(15.dp))
                        MobileNumberRow(viewModel)
                        Spacer(modifier = Modifier.height(15.dp))
                        AddressRow(onClick = {
                            AppNavigator.shared().navigate(AccountNavRoute.ADDRESS)
                        })
                        if(customer.value?._id?.isNotEmpty() == true){
                            Spacer(modifier = Modifier.height(15.dp))
                            MembershipRow(viewModel = customerViewModel, authViewModel = viewModel)
                            Spacer(modifier = Modifier.height(15.dp))
                        }
//                        LanguageRow(selectedLanguage.value)
                        Spacer(modifier = Modifier.height(15.dp))
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(60.dp)
                                .padding(start = 8.dp, end = 8.dp)
                                .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                                .clip(RoundedCornerShape(10.dp))
                                .clickable {
                                    viewModel.logout()
                                    AppNavigator.shared().navigate(AccountNavRoute.DELETE)
                                }
                                .padding(5.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(
                                Icons.Filled.Delete,
                                contentDescription = "Delete",
                                modifier = Modifier.weight(0.05f),
                                tint = ThemeColor.shared().Red
                            )
                            Text("Delete Account", modifier = Modifier.weight(0.2f))
                            Icon(
                                Icons.Filled.Delete,
                                "Delete",
                                modifier = Modifier.weight(0.03f),
                                tint = ThemeColor.shared().Red
                            )
                        }
                        Spacer(modifier = Modifier.height(15.dp))
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(60.dp)
                                .padding(start = 8.dp, end = 8.dp)
                                .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                                .clip(RoundedCornerShape(10.dp))
                                .clickable {
                                    viewModel.logout()
                                    AlertHandler.shared().showAlert(
                                        localization().accounts.logoutAlertTitle,
                                        localization().accounts.logoutAlertMessage
                                    )
                                }
                                .padding(5.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(
                                Icons.Filled.Power,
                                contentDescription = "Home",
                                modifier = Modifier.weight(0.05f),
                                tint = ThemeColor.shared().iconTint
                            )
                            Text(localization().accounts.logout, modifier = Modifier.weight(0.2f))
                            Icon(
                                Icons.Filled.ArrowCircleRight,
                                "Language",
                                modifier = Modifier.weight(0.03f),
                                tint = ThemeColor.shared().iconTint
                            )
                        }


                    }
                }
                Text(
                    "Version ${AppConfig.shared().version}",
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth().height(30.dp)
                )
            }
        } else {
            Column {
                TopNavBar(title = localization().accounts.accountsTitle, AppNavigator.shared().getNavigationParam())
                Row(
                    modifier = Modifier
                        .height(80.dp)
                        .padding(start = 8.dp, end = 8.dp, top = 8.dp)
                        .background(Color(0x8DB3B0B0), shape = RoundedCornerShape(10.dp))
                        .clip(RoundedCornerShape(10.dp))
                        .clickable {
                            viewModel.showAuthContainer()
                        }
                        .padding(5.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FriendlyIcon(name = ImageAsset.logoutIcon, size = 30)
                    Text(
                        localization().accountAuthentication.loginRegister,
                        modifier = Modifier.weight(0.2f)
                    )
                    Icon(
                        Icons.Filled.ArrowCircleRight,
                        "Language",
                        modifier = Modifier.weight(0.03f),
                        tint = ThemeColor.shared().iconTint
                    )
                }
                Text(
                    "Version ${AppConfig.shared().version}",
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }

    }
}
